<template>
  <b-card :class="cardClass" @click="focusEditor()">
    <template v-slot:header>
      <b-button-group>
        <b-btn title="Negreta (Ctrl+B)" size="sm"
               :variant="editor && editor.isActive('bold') ? 'dark' : 'light'"
               @click="editor.chain().focus().toggleBold().run()">
          <font-awesome-icon :icon="['fas', 'bold']"/>
        </b-btn>
        <b-btn title="Cursiva (Ctrl+I)" size="sm"
               :variant="editor && editor.isActive('italic') ? 'dark' : 'light'"
               @click="editor.chain().focus().toggleItalic().run()">
          <font-awesome-icon :icon="['fas', 'italic']"/>
        </b-btn>
        <b-btn title="Subratllat (Ctrl+U)" size="sm"
               :variant="editor && editor.isActive('underline') ? 'dark' : 'light'"
               @click="editor.chain().focus().toggleUnderline().run()">
          <font-awesome-icon :icon="['fas', 'underline']"/>
        </b-btn>
        <b-btn title="Ratlla" size="sm"
               :variant="editor && editor.isActive('strike') ? 'dark' : 'light'"
               @click="editor.chain().focus().toggleStrike().run()">
          <font-awesome-icon :icon="['fas', 'strikethrough']"/>
        </b-btn>
        <b-btn title="Llista de pics (Ctrl+Shift+8)" size="sm"
               :variant="editor && editor.isActive('bulletList') ? 'dark' : 'light'"
               @click="editor.chain().focus().toggleBulletList().run()">
          <font-awesome-icon :icon="['fas', 'list-ul']"/>
        </b-btn>
        <b-btn title="Llista numerada (Ctrl+Shift+9)" size="sm"
               :variant="editor && editor.isActive('orderedList') ? 'dark' : 'light'"
               @click="editor.chain().focus().toggleOrderedList().run()">
          <font-awesome-icon :icon="['fas', 'list-ol']"/>
        </b-btn>
        <b-btn title="Desfer (Ctrl+Z)" size="sm" variant="light" @click="editor && editor.chain().focus().undo().run()">
          <font-awesome-icon :icon="['fas', 'undo']"/>
        </b-btn>
        <b-btn title="Refer (Ctrl+Shift+Z)" size="sm" variant="light" @click="editor && editor.chain().focus().redo().run()">
          <font-awesome-icon :icon="['fas', 'redo']"/>
        </b-btn>
      </b-button-group>
    </template>
    <editor-content v-if="editor" :editor="editor" class="details"/>
  </b-card>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-2'
import StarterKit from '@tiptap/starter-kit'
import Bold from '@tiptap/extension-bold'
import Italic from '@tiptap/extension-italic'
import Underline from '@tiptap/extension-underline'
import Strike from '@tiptap/extension-strike'
import Blockquote from '@tiptap/extension-blockquote'
import BulletList from '@tiptap/extension-bullet-list'
import OrderedList from '@tiptap/extension-ordered-list'
import ListItem from '@tiptap/extension-list-item'
import History from '@tiptap/extension-history'
import Link from '@tiptap/extension-link'
import Paragraph from '@tiptap/extension-paragraph'

export default {
  components: {
    EditorContent
  },
  data() {
    return {
      cardClass: 'text-left',
      editor: null  // Inicialitzem a null per evitar errors d'accés abans de la creació
    }
  },
  methods: {
    focusEditor() {
      if (this.editor) {
        this.editor.commands.focus()
      }
    }
  },
  mounted() {
    this.editor = new Editor({
      extensions: [
        StarterKit,  // Inclou History, no cal afegir-lo de nou
        Bold,
        Italic,
        Underline,
        Strike,
        Blockquote,
        BulletList,
        OrderedList,
        ListItem,
        Link,
        Paragraph
      ],
      content: '',
      autofocus: true,
      onUpdate: ({ editor }) => {
        this.$emit('updateDetails', {
          details: editor.getHTML()
        })
      }
    })
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy()  // Comprovació per evitar errors
    }
  }
}
</script>

<style scoped>
::v-deep .ProseMirror:focus {
  outline: none;
}

.card-header {
  padding: 0;
}

.card-body {
  height: 350px;
  padding: 0;
  margin: 0;
  overflow: auto;
  cursor: text;
}

.focus {
  border-color: rgba(82, 168, 236, .8);
  outline: 0;
  box-shadow: 0 0 8px rgba(82, 168, 236, .6) !important;
}

.details {
  margin: 10px;
  display: flex;
  flex-direction: column;
}
</style>
